/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builder_Actions_HintInputs */

const cs_builder_actions_hint = /** @type {(inputs: Builder_Actions_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uložit uloží šablonu. Náhled zkompiluje PDF. Generovat spustíte z inzerátu.`)
};

const en_builder_actions_hint = /** @type {(inputs: Builder_Actions_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save stores the template. Preview compiles a PDF. Generate runs from a listing.`)
};

/**
* | output |
* | --- |
* | "Save stores the template. Preview compiles a PDF. Generate runs from a listing." |
*
* @param {Builder_Actions_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const builder_actions_hint = /** @type {((inputs?: Builder_Actions_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builder_Actions_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_builder_actions_hint(inputs)
	return cs_builder_actions_hint(inputs)
});